import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Pagination from "@mui/lab/Pagination";
import CandidateCardNew from "bundles/common/components/CandidateCardNew";
import { useSelector } from "react-redux";

const CVThequeCandidateList = ({
  candidates,
  selectedCandidate,
  setSelectedCandidate,
  page,
  pageCount,
  onPageChange,
  favorites = [],
  onFavoriteToggle,
}) => {
  const theme = useTheme();
  const currentRecruiter = useSelector((state) => state.current_recruiter);

  return (
    <Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}
      >
        <Grid container spacing={2}>
          {candidates?.map((candidate, i) => {
            const isSelected = selectedCandidate?.id === candidate.id;
            const isCandidateRevealed = currentRecruiter?.candidate_interests?.some(
              (interest) => interest.candidate_id === candidate?.id
            );
            return (
              <Grid
                item
                xs={12}
                key={`candidate-${candidate.id || i}`}
                onClick={() => setSelectedCandidate(candidate)}
                sx={{
                  cursor: "pointer",
                  borderRadius: "12px",
                  "& > .MuiCard-root": {
                    transition: "background-color 0.2s ease",
                    backgroundColor: isCandidateRevealed
                      ? "rgba(173, 216, 230, 0.2)"
                      : isSelected
                        ? alpha(theme.palette.primary.main, 0.06)
                        : theme.palette.common.white,
                  },
                }}
              >
                <CandidateCardNew
                  candidate={candidate}
                  chipVariant="availability"
                  showCloseIcon={false}
                  showSaveIcon={true}
                  showMetaChips={true}
                  showLastActive={true}
                  pinSaveIconToBottom={false}
                  favorites={favorites}
                  handleFavoriteToggle={onFavoriteToggle}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* Pagination */}
      {pageCount > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            size="large"
            onChange={onPageChange}
            count={pageCount}
            page={page}
            variant="outlined"
            color="secondary"
          />
        </Box>
      )}
    </Box>
  );
};

export default CVThequeCandidateList;
